export default __webpack_public_path__ + "static/media/Aquina_FullColor.2c341812.png";